import React from 'react';
import { useIntl } from 'react-intl';
import { DataValue } from '../../../utils/updateLocalDataObject';
import TFRadioInput from '../../TFRadioInput/TFRadioInput';
import Card from './Card';
import Label from './Label';

interface EditDefectApprovalReleaseRequiredProps {
  approvalReleaseName: string;
  defectRename: string;
  approvalReleaseRequired: boolean;
  updateDefectData: (changes: { value: DataValue; key: string }[]) => void;
}

const EditDefectApprovalReleaseRequired: React.FC<EditDefectApprovalReleaseRequiredProps> = ({
  approvalReleaseName,
  defectRename,
  approvalReleaseRequired,
  updateDefectData,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Card marginTop={20} identifier="EditApprovalReleaseRequired">
      <Label marginBottom={20} fontWeight={600}>
        {approvalReleaseName}
      </Label>
      <Label marginBottom={10} fontWeight={500}>
        {formatMessage(
          { id: 'text.isAnApprovalReleaseRequired' },
          { fieldOne: approvalReleaseName, fieldTwo: defectRename }
        )}
      </Label>

      <TFRadioInput
        id="approvalReleaseRequired"
        options={[
          { title: 'Yes', value: true },
          { title: 'No', value: false },
        ]}
        value={approvalReleaseRequired}
        onChange={(value: boolean) => updateDefectData([{ value, key: 'approval_release_required' }])}
      />
    </Card>
  );
};

export default EditDefectApprovalReleaseRequired;
